
import { defineComponent } from 'vue'
import { iColumn, iPhysicalModel } from '../../Metaweb'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Listbox from 'primevue/listbox'

export default defineComponent({
    name: 'metaweb-physical-model-list',
    components: { Accordion, AccordionTab, Listbox },
    props: { propMeta: { type: Object } },
    emits: ['selected'],
    data() {
        return {
            meta: null as any,
            selectedPhysicalModel: null as iColumn | iPhysicalModel | null
        }
    },
    watch: {
        propMeta() {
            this.loadMeta()
        }
    },
    created() {
        this.loadMeta()
    },
    methods: {
        loadMeta() {
            this.meta = this.propMeta as any
        },
        emitSelectedItem() {
            this.$emit('selected', this.selectedPhysicalModel)
        },
        setSelected(index: number) {
            this.selectedPhysicalModel = this.meta.physicalModels[index]
            this.$emit('selected', this.selectedPhysicalModel)
        }
    }
})
